<template>
    <v-layout row wrap>
      <v-container grid-list-xs>
        <v-toolbar color="white" mb-2 >
          <v-breadcrumbs :items="breadCrumbItems">
            <template v-slot:item="props">
              <a @click.prevent="props.item.function" :class="[props.item.disabled && 'disabled']">{{ props.item.text.toUpperCase() }}</a>
            </template>
          </v-breadcrumbs>
        </v-toolbar>
        <v-layout mt-2>
          <v-flex xs12 v-if="showDetail" >
            <v-container :class="{'px-1': $vuetify.breakpoint.smAndDown}" fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3 v-for="product in productsToShow" :key="product.id" >
                  <v-card class="rounded-card">
                    <v-img v-if="pictures[product.picture_path]" :src="'data:image/jpeg;base64,'+pictures[product.picture_path]" aspect-ratio="1.5" ></v-img>
                    <v-img v-else src="/img/img_not_found.png" aspect-ratio="1.5" contain></v-img>
                    <v-card-text>
                        <v-layout row wrap justify-center align-center v-if="product.serial_number">
                          <v-flex xs12 py-1 class="text-xs-center">
                            <h2><span class="orange--text" v-if="product.pair">(P) </span>{{product.serial_number}}</h2>
                          </v-flex>
                          <v-flex xs12 py-1 class="text-xs-center">
                            <h3><div >{{product.maker_name}}</div></h3>
                          </v-flex>
                          <v-flex xs12 py-1 class="text-xs-center">
                            <div class="subheading">{{product.description}}</div>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap justify-center v-if="hasRole('ADMINISTRATOR') && product.serial_number">
                          <v-flex xs12 py-1 class="text-xs-center">
                            <div class="">{{product.weigth_grams | currency('', 0)}} gr</div>
                          </v-flex>
                          <v-flex xs12 py-1 class="text-xs-center">
                            <div class="">{{product.dollar_price | currency}} Dll</div>
                          </v-flex>
                          <v-flex xs12 py-1 class="text-xs-center">
                            <div class="">{{product.country_name}}</div>
                          </v-flex>

                        </v-layout>
                      <v-flex xs12 py-1
                        class="text-xs-center"
                      >
                          <a color="success" @click="findSimilar(product.picture_path)">Ver similares</a>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 v-else>
            <v-card>
              <v-container grid-list-sm fluid>
                <v-layout row wrap>
                  <v-flex
                    v-for="m in makers"
                    :key="m.id"
                    xs6
                    md3
                    d-flex
                    mb-5
                  >
                    <v-card flat tile class="d-flex" >
                      <a @click="clickOnMaker(m)">
                        <v-img
                          :src="m.img_url"
                          :aspect-ratio="16/9"
                          contain
                        >
                          <template v-slot:placeholder>
                          <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-layout>
                        </template>
                        </v-img>
                      </a>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

    </v-layout>
</template>
<script>
export default {
  data() {
    return {
      makers: [],
      showDetail: false,
      products: [],
      pictures: [],
      breadCrumbItems: [{text: 'Marca', function: this.resetToRoot, disabled: true}],
      findingSimilar: false,
    };
  },
  methods: {
    async buildImageUrl(m) {
      const results = await this.axios.get('/img/' + m);
      console.log(results.data)
      return results.data
    },
    async resetToRoot() {
      if (!this.breadCrumbItems[0].disabled) {
        try {
          const results = await this.axios.get('/catalogs/maker/display');
          this.makers = results.data;
          this.products = [];
          this.pictures = [];
          this.showDetail = false;
          this.breadCrumbItems[0].disabled = true;
          this.findingSimilar = false;
          this.breadCrumbItems = [this.breadCrumbItems[0]];
        } catch (error) {
          this.$emit('error', error);
        }
      }
    },
    async clickOnMaker(maker) {
      this.$router.push({
          name: 'products',
          params: {
              branch: maker.name
          }
      });
    },
    async findSimilar(path) {
      try {
        this.products = [];
        this.pictures = [];

        this.loadingProducts = true;
        this.reqBody = {
          picture_path: path,
          no_zero: true,
          pagination: {
            current_page: this.currentPage,
            per_page: this.perPage,
          },
        };
        const results = await this.axios.post(`/catalogs/product/search?${this.thumbQueryParam}`, this.reqBody);
        this.products = results.data.products;
        this.pictures = results.data.pictures;
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.loadingProducts = false;
        this.findingSimilar = true;
        delete this.reqBody.picture_path;
      }
    },
    hasRole(roleName) {
      if (!this.$store.getters.getProfile.roles) {
        return false;
      }
      const found = this.$store.getters.getProfile.roles.filter((e) => {
        return roleName === e.name;
      });
      return found.length > 0;
    },
  },
  computed: {
    rootUrl() {
      return process.env.VUE_APP_ROOT_API;
    },
    currentList() {
      if (!this.$store.state.user.profile.currentList) {
        return {};
      }
      return this.$store.state.user.profile.currentList;
    },
    currentListPercentage() {
      if (this.$store.getters.getProfile && this.$store.getters.getProfile.currentList) {
        return this.$store.getters.getProfile.currentList.percentage / 100;
      }
      return 0;
    },
    productsToShow() {
      if (this.findingSimilar) {
        this.product = this.products.sort((a, b) => (a.pesos_price < b.pesos_price) ? -1 : 1 )[0];
      }
      if (this.currentType === 'CLIENT' && this.findingSimilar) {
        if (this.product.length === 1) {
          return this.products;
        }
        const PERCENTAGE = 40;
        const LIMIT_FACTOR = 1.0 + (PERCENTAGE / 100);
        const cheaper = this.products[0];
        const UPPER_LIMIT = cheaper.pesos_price * LIMIT_FACTOR;
        return this.products.filter((p) => {
          const shouldShow = p.pesos_price <= UPPER_LIMIT;
          return shouldShow;
        });
      } else {
        return this.products.filter((p) => {
          const shouldShow =
            (this.pictures[p.picture_path]);
          return shouldShow;
        });
      }
    },
  },
  async mounted() {
    try {
      const results = await this.axios.get('/catalogs/maker/display');
      const data = results.data
      const updatedMakers = await Promise.all(
        data.map(async m => {
          const imageUrl = await this.buildImageUrl(m.img_path);
          return {
            ...m,
            img_url: imageUrl
          };
        })
      );
      this.makers = updatedMakers;
      console.log(this.makers);
      
    } catch (error) {
      this.$emit('error', error);
    }
  },
};
</script>
<style scoped>
  .disabled{
    color: grey;
    pointer-events: none;
  }
</style>